import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { Table,  TableBody, TableCell, TableRow, Typography } from '@mui/material';
import EnvironmentDefs from '../../EnvironmentDefs';
import AppLogo from '../ui/AppLogo';

const envDefs = new EnvironmentDefs();

const styleSheet = theme => ({
    root: {
        flexGrow: 1,
      },
    flex: {
        flex: 1,
    },
    [theme.breakpoints.up('sm')]: {
        tblCellLogoCol: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingBottom: 0,
            paddingRight: 10,
            width: 52,
            verticalAlign: 'top',
            borderBottom: 0,
        },
        tblCellDescCol: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingBottom: 0,
            paddingRight: 0,
            width: 948,
            verticalAlign: 'top',
            borderBottom: 0,
        },
    },
    [theme.breakpoints.up('xs')]: {
        tblCellLogoCol: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 10,
            width: 52,
            verticalAlign: 'top',
            borderBottom: 0,
        },
        tblCellDescCol: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            verticalAlign: 'top',
            borderBottom: 0,
        }
    },
});
/*
* This component displays landing page header information.  It has the logo, landing name and the full URL
* formatted in a consistent fashion.
*/
class LandingHeaderDisplay extends Component {

    getLandingName = () => {
        let theLandingName = 'New landing page';
        if (this.props.displayMode && this.props.displayMode === 'so') {
          theLandingName = 'New subscription order page';
        }
        if (this.props.landingName && this.props.landingName !== '') {
            theLandingName = this.props.landingName;
        } else if (this.props.landingPath && this.props.landingPath !== '') {
            theLandingName = this.props.landingPath;
        } else if (this.props.defaultTitle) {
            theLandingName = this.props.defaultTitle;
        }
        return theLandingName;
    }

    getUrl = () => {
        let fullLandingPath = '';
        if (this.props.displayMode && this.props.displayMode === 'landing') {
            if (envDefs.getEnv() === "poc" || envDefs.getEnv() === "devpoc") {
                fullLandingPath = "https://poc.appbind.com/partner/" + this.props.accountPath + "/" + this.props.landingPath;
            } else if (envDefs.getEnv() !== "poc" && envDefs.getEnv() !== "devpoc") {
                fullLandingPath = "https://app.appbind.com/partner/" + this.props.accountPath + "/" + this.props.landingPath; 
            }
        } else {
            if (envDefs.getEnv() === "poc" || envDefs.getEnv() === "devpoc") {
                fullLandingPath = "https://poc.appbind.com/order/" + this.props.accountPath + "/" + this.props.landingPath;
            } else if (envDefs.getEnv() !== "poc" && envDefs.getEnv() !== "devpoc") {
                fullLandingPath = "https://app.appbind.com/order/" + this.props.accountPath + "/" + this.props.landingPath; 
            }
        }

        return fullLandingPath;
    }

    getSignupUrl = () => {
        let signupUrl = null;
        if (this.props.displayMode && this.props.displayMode === 'landing' && this.props.parmValue) {
            if (envDefs.getEnv() === "poc" || envDefs.getEnv() === "devpoc") {
                signupUrl = "https://poc.appbind.com/signup?app=" + this.props.parmValue;
            } else if (envDefs.getEnv() !== "poc" && envDefs.getEnv() !== "devpoc") {
                signupUrl = "https://app.appbind.com/signup?app=" + this.props.parmValue; 
            }
        }

        return signupUrl;
    }

    render() {
        const classes = this.props.classes;
        let landingUrlLabel = 'Subscription order URL: ' + this.getUrl();
        let signupUrlLabel = null;
        let sUrl = this.getSignupUrl();
        if (this.props.displayMode && this.props.displayMode === 'landing') {
            landingUrlLabel = 'Landing page URL: ' + this.getUrl();
            if (sUrl != null) {
                signupUrlLabel = 'Sign up URL: ' + sUrl;
            }
        }

        return (
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell className={classes.tblCellLogoCol}>
                            <AppLogo logoPath={this.props.logo} appName="App" imageHeight='48px'/>
                        </TableCell>
                        <TableCell className={classes.tblCellDescCol}>
                            <Typography variant="h6">{this.getLandingName()}</Typography>
                            <Typography variant="body2">{landingUrlLabel}</Typography>
                            { signupUrlLabel != null &&
                            <Typography variant="body2">{signupUrlLabel}</Typography>}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        );
    }

}
  
export default withStyles(styleSheet)(LandingHeaderDisplay);